export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const REFRESH_TOKEN = 'REFRESH_TOKEN';

// user
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_TRADES = 'UPDATE_TRADES';
export const UPDATE_WITHDRAWALS = 'UPDATE_WITHDRAWALS';

// misc
export const ONBOARDED = 'ONBOARDED';
export const TOGGLE_BIO = 'TOGGLE_BIO';
export const TOGGLE_BALANCE = 'TOGGLE_BALANCE';

export const UPDATE_BANKS = 'UPDATE_BANKS';
export const UPDATE_USERS_BANKS = 'UPDATE_USERS_BANKS';
export const UPDATE_BANK_MAP = 'UPDATE_BANK_MAP';

export const SET_CARDS = 'SET_CARDS';

export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';
export const UPDATE_CURRENCY = 'UPDATE_CURRENCY';
